var Refresher = /** @class */ (function () {
    function Refresher(table) {
        this.table = table;
    }
    Refresher.prototype.getRows = function (ids) {
        return jQuery.ajax({
            url: window.location.href,
            method: 'post',
            data: {
                ac_action: 'get_table_rows',
                ac_ids: ids,
                _ajax_nonce: AC.ajax_nonce
            }
        });
    };
    Refresher.prototype.updateRow = function (id) {
        var _this = this;
        var ajax = this.getRows([id]);
        ajax.done(function (response) {
            if (response.success) {
                _this.populateRow(id, response.data.table_rows[id]);
            }
        });
    };
    Refresher.prototype.populateRow = function (id, rowdata) {
        // Only change if value has changed
        var element = document.createElement('table');
        element.insertAdjacentHTML('beforeend', rowdata);
        this.table.Cells.getByID(id).forEach(function (cell) {
            var td = element.querySelector("td.column-" + cell.getName());
            cell.setValue(td.innerHTML);
        });
    };
    return Refresher;
}());
export default Refresher;
